import type { MapLine, MapPoint } from './Map';

const DEFAULT_ROUTE_COLOR = '#005f8f';
const ROUTE_BORDER_COLOR = '#ffffff';
const ROUTE_LINE_WIDTH = 3;
const ROUTE_BORDER_WIDTH = 9;
const ROUTE_ENDPOINT_RADIUS = 4;
const ROUTE_ENDPOINT_BORDER_WIDTH = 3;

export function resolveRouteColor(
  background?: string | null,
  foreground?: string | null,
): string {
  if (!background) {
    return DEFAULT_ROUTE_COLOR;
  }

  if (background.toUpperCase() === '#FFFFFF') {
    return foreground ?? DEFAULT_ROUTE_COLOR;
  }

  return background;
}

export function createRouteLine(
  line: Pick<MapLine, 'coordinates' | 'id'>,
  color?: string | null,
): MapLine {
  const routeColor = color ?? DEFAULT_ROUTE_COLOR;

  return {
    ...line,
    color: routeColor,
    borderColor: ROUTE_BORDER_COLOR,
    width: ROUTE_LINE_WIDTH,
    borderWidth: ROUTE_BORDER_WIDTH,
    showEndpoints: true,
    endpointColor: ROUTE_BORDER_COLOR,
    endpointRadius: ROUTE_ENDPOINT_RADIUS,
    endpointBorderColor: routeColor,
    endpointBorderWidth: ROUTE_ENDPOINT_BORDER_WIDTH,
  };
}

export function createRoutePoint(
  point: Pick<MapPoint, 'coordinate' | 'id'>,
  color?: string | null,
): MapPoint {
  const routeColor = color ?? DEFAULT_ROUTE_COLOR;

  return {
    ...point,
    color: ROUTE_BORDER_COLOR,
    radius: ROUTE_ENDPOINT_RADIUS,
    borderColor: routeColor,
    borderWidth: ROUTE_ENDPOINT_BORDER_WIDTH,
  };
}
